(function() {
    'use strict';
    angular
        .module('consinfApp')
        .factory('ConsInfAccount', ConsInfAccount);

    ConsInfAccount.$inject = ['$resource', 'DateUtils'];

    function ConsInfAccount ($resource, DateUtils) {
        var resourceUrl =  'api/cons-inf-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                        data.renewalDate = DateUtils.convertLocalDateFromServer(data.renewalDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.renewalDate = DateUtils.convertLocalDateToServer(copy.renewalDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.renewalDate = DateUtils.convertLocalDateToServer(copy.renewalDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
